/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { INTERCOM_APP_ID } from '@fai/friendli-suite/shared/intercom/id';

/**
 * @url https://developers.intercom.com/installing-intercom/web/installation/#step-1-include-intercom-js-library
 * @note LSY: APP_ID is not secret
 */
export default function InitIntercom() {
  /**
   * @url https://developers.intercom.com/installing-intercom/web/attributes-objects/
   */
  window.intercomSettings = {
    app_id: INTERCOM_APP_ID,
    api_base: 'https://api-iam.intercom.io',
  };

  const appendIntercomScript = () => {
    const { Intercom } = window;

    if (typeof Intercom === 'function') {
      Intercom('reattach_activator');
      Intercom('update', { app_id: INTERCOM_APP_ID });
    } else {
      const appendScript = () => {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;

        const x = document.querySelectorAll('script')[0];
        x.parentNode?.insertBefore(s, x);
      };

      if (document.readyState === 'complete') {
        appendScript();
      } else {
        window.addEventListener('load', appendScript, false);
      }
    }
  };

  appendIntercomScript();
}
